"use client";
import { Table, Pagination, Dropdown, Modal, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import "./PRmanager.css";
import Cards from "./Cards";
import { Link } from "react-router-dom";
import Instance from "../../Utils/Axios";
import PRtable from "./PRtable";

export default function Pending() {
  const [cardData, setCardData] = useState(null);

  // Data fetching is now handled by PRtable

  return (
    <>
      <Cards cardData={cardData} />
      <div className="my_press">
        <h4 className="my_press_text">My Press Releases</h4>
        <div className="my_press_btns">
          <Link to="/customer/pr-manager">
            <button className="my_view_btn">View all</button>
          </Link>
          <Link to="/customer/submit-pr">
            <button className="my_add_btn">
              <img
                className={"pr_add_img mb-0"}
                src="/build/img/Icons/Vector.png"
                alt="zex pr wire Logo"
                width={13}
                height={13}

              />
              Add new
            </button>
          </Link>
        </div>
      </div>
      <PRtable status="PENDING" onStatsFetch={setCardData} />
    </>
  );
}
